import { createAxiosForRailsApi } from '../../common/utils/http';

export default class CriteriaAPI {
  constructor() {
    this.client = createAxiosForRailsApi();
    this.client.defaults.baseURL = '/search/criterias';
  }

  mines() {
    return this.client.get('/');
  }

  add(params) {
    return this.client.post('/', params).then(response => {
      if (!response.data.search_criteria) {
        throw response.data;
      }

      return Promise.resolve(response.data.search_criteria);
    });
  }

  delete(searchCriteriaId) {
    return this.client.delete(`/${searchCriteriaId}`);
  }
}
